import EventEmitter from 'events'

export class Sizes extends EventEmitter {
  constructor(canvasContainer) {
    super()

    // Resources
    this._container = canvasContainer

    // Setup
    this.width = window.innerWidth
    this.height = this._container.getBoundingClientRect().height
    this.pixelRatio = Math.min(window.devicePixelRatio, 2)
    this.aspectRatio = this.width / this.height
    this.isMobile = this.aspectRatio < 1.2

    // Listeners
    this._resizeHandler = () => {
      this.width = window.innerWidth
      this.height = this._container.getBoundingClientRect().height
      this.pixelRatio = Math.min(window.devicePixelRatio, 2)

      const newAspectRatio = this.width / this.height
      if ((this.isMobile && newAspectRatio >= 1.2) || (!this.isMobile && newAspectRatio < 1.2)) {
        this.isMobile = newAspectRatio < 1.2
        this.emit('switchViewport', this.isMobile ? 'mobile' : 'desktop')
      }
      this.aspectRatio = newAspectRatio

      this.emit('resize')
    }

    window.addEventListener('resize', this._resizeHandler)
  }

  destroy() {
    window.removeEventListener('resize', this._resizeHandler)
  }
}
